// percorso.ts — navigazione minima tra le pagine dell'app (senza librerie): /, /c/<codice>, /admin.
import { useSyncExternalStore } from "react";

const EVENTO = "ld:percorso";

export function vai(percorso: string, sostituisci = false): void {
  if (sostituisci) history.replaceState(null, "", percorso);
  else history.pushState(null, "", percorso);
  window.dispatchEvent(new Event(EVENTO));
}

function iscrivi(f: () => void): () => void {
  window.addEventListener("popstate", f);
  window.addEventListener(EVENTO, f);
  return () => {
    window.removeEventListener("popstate", f);
    window.removeEventListener(EVENTO, f);
  };
}

export function usePercorso(): string {
  return useSyncExternalStore(iscrivi, () => window.location.pathname);
}
